import { HoverHintWrapper, Table } from "@domain-group/suit-theme"
import { faBox, faChevronRight, faNewspaper, faStore, faTruck, IconDefinition } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DateTime } from 'luxon'
import useTemplatePage, { useRelations } from "@hooks/useTemplatePage"
import { TemplatePageModel } from "@models/templatePage"

interface IconProps {
  title: string,
  icon: IconDefinition
}

const Icon = (props: IconProps) => {
  const {title, icon} = props

  return (
    <HoverHintWrapper
      childrenHolderProps={{ color: 'bodyFontLightColor'}}
      hintComponent={<HoverHintWrapper.Hint>{title}</HoverHintWrapper.Hint>}
    >
      <FontAwesomeIcon title="Providers" icon={icon} />
    </HoverHintWrapper>
  )
}
interface ListViewProps {
  templatePages: TemplatePageModel[]
  setSelectedTemplatePage: (page: TemplatePageModel) => void
}

const ListView = (props: ListViewProps) => {
  const { templatePages, setSelectedTemplatePage } = props

  const mappedTemplatePages = () => {
    return templatePages.map(page => {
      const templatePagePayload = useTemplatePage(page)
      const {
        permissionCounts,
      } = templatePagePayload

      const { brand } = useRelations(page)

      return {
        title: page.title,
        id: page.id,
        brand_id: brand.id,
        brand_name: brand.title,
        created_on: page.dates.created.date_time_with_timezone,
        providerCount: permissionCounts.providers,
        productsCount: permissionCounts.products,
        publicationsCount: permissionCounts.publications,
        agenciesCount: permissionCounts.agencies,
        originalPage: page,
      }
    })
  }

  const iconWidth = '60px'

  return (
    <Table
      columns={[
        {
          title: 'Title',
          dataKey: 'title',
          render: (value) => (value),
        },
        {
          title: 'ID',
          dataKey: 'id',
          render: (value) => (value),
        },
        {
          title: 'Brand ID',
          dataKey: 'brand_id',
          render: (value) => (value)
        },
        {
          title: "Brand Name",
          dataKey: 'brand_name',
          render: (value) => (value),
        },
        {
          title: "Created On",
          dataKey: 'created_on',
          render: (value) => {
            if (!value) return null
            return DateTime.fromISO(value).toFormat('dd LLL yyyy')
          }
        },
        {
          title: <Icon title="Providers" icon={faTruck} />,
          dataKey: 'providerCount',
          cellProps: { width: iconWidth, textAlign: 'center' },
          render: (value) => (value),
        },
        {
          title: <Icon title="Products" icon={faBox} />,
          dataKey: 'productsCount',
          cellProps: { width: iconWidth, textAlign: 'center' },
          render: (value) => (value),
        },
        {
          title: <Icon title="Publications" icon={faNewspaper} />,
          dataKey: 'publicationsCount',
          cellProps: { width: iconWidth, textAlign: 'center' },
          render: (value) => (value),
        },
        {
          title: <Icon title="Agencies" icon={faStore} />,
          dataKey: 'agenciesCount',
          cellProps: { width: iconWidth, textAlign: 'center' } ,
          render: (value) => (value),
        },
        {
          title: '',
          dataKey: 'id',
          render: (_value: unknown, row) => (
            <FontAwesomeIcon
              icon={faChevronRight}
              onClick={() => setSelectedTemplatePage(row.originalPage)}
              style={{ cursor: 'pointer' }}
            />
          ),
        },
      ]}
      data={mappedTemplatePages()}
      boxProps={{ border: 'none', boxShadow: 'none' }}
    />
  )
}

export default ListView